export default __webpack_public_path__ + "static/media/supermarket-icon.3741010f.png";